var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.rowData.categories.length)?_c('div',{staticClass:"flex-left"},_vm._l((_vm.rowData.categories),function(category){return _c('badge',{key:category.id,attrs:{"username":category.name,"backgroundColor":category.color}})}),1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e7406ed8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Organization/Customers/CategoriesCell.vue
// module id = FUFQ
// module chunks = 1